import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

const ExternalIcon = ({ size = 16, color = '#A9A9A9', ...props }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83982 4.78334C3.26749 4.78334 2.80353 5.25399 2.80353 5.83457V12.124C2.80353 12.7046 3.26749 13.1752 3.83982 13.1752H10.0398C10.6121 13.1752 11.0761 12.7046 11.0761 12.124V7.90109H12.5464V12.124C12.5464 13.5283 11.4241 14.6667 10.0398 14.6667H3.83982C2.45548 14.6667 1.33325 13.5283 1.33325 12.124V5.83457C1.33325 4.43026 2.45548 3.29185 3.83982 3.29185H8.00266V4.78334H3.83982Z"
        fill={color}
      />
      <path
        d="M9.45304 1.38398L13.9032 1.33484C13.9124 1.33167 13.9214 1.33464 13.9273 1.33458C14.0904 1.33278 14.2469 1.38616 14.3668 1.47669C14.3758 1.48582 14.3878 1.49175 14.3968 1.50088C14.4179 1.51594 14.4358 1.53411 14.4538 1.55229L14.5016 1.60687C14.5106 1.616 14.5165 1.62815 14.5255 1.63728C14.618 1.76178 14.6681 1.91742 14.6666 2.08277C14.6665 2.08892 14.6664 2.10123 14.6663 2.10721L14.6278 6.62155C14.6261 6.82988 14.54 7.02062 14.4029 7.15994C14.2659 7.29927 14.0779 7.38714 13.8727 7.38931C13.4621 7.39384 13.1299 7.0576 13.1304 6.63806L13.1536 3.92456L8.21122 8.94942C7.91886 9.24666 7.44188 9.25192 7.15453 8.96109C7.01089 8.81571 6.94012 8.62047 6.93874 8.42757C6.94041 8.23153 7.01448 8.04086 7.16367 7.88918L12.1061 2.8644L9.43115 2.89394C9.02057 2.89847 8.68836 2.56223 8.68891 2.14269C8.70445 1.73212 9.04245 1.38852 9.45304 1.38398Z"
        fill={color}
      />
    </svg>
  );
};

export default ExternalIcon;
